import Banner from "../Banner/Banner";
import './About.css'
import about1 from "../images/about.png"
import { Link } from "react-router-dom";
export function About(){
    return(
        <section className="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6  ">
                            <div className="images">
                               <img src={about1}/>
                            </div>
                        </div>
                        <div className="col-lg-6  about-right">
                            <h6>About Us</h6>
                            <h2>The Great Place Of Medical Hospital Center</h2>
                            <p>We provide the special tips and advice’s of heath care treatment and high level of best technology involve in the our hospital.</p>
                            <div className="icons">
                                <li className="truck-medical"><i className="fa-solid fa-truck-medical"></i> Emergency Help</li>
                                <li className="user-doctor"><i className="fa-solid fa-user-doctor"></i> Qualified Doctors</li>
                                <li className="hand-holding-medical"><i className="fa-solid fa-hand-holding-medical"></i> Best Professionals</li>
                                <li className="syringe"><i className="fa-solid fa-syringe"></i> Medical Treatment</li>
                            </div>
                            <Link><button className="btn">Read More</button></Link>
                        </div>
                    </div>
                </div>
            </section>
    )
}
function about(){
    return(
        <>
            <Banner title="About Us" smtitle="about" />
            <About/>
        </>
    )
}

export default about;
